

























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { BusinessWalletDashboard } from '@/api/interfaces/business-wallet-dashboard.interface';
import { insideProviderIframe } from '@/utils/providerIframe';
import { AnalyticsCardListItem } from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import Link from '@/componentsV2/atoms/Link/Link.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import ExternalLinkIcon from '@/components/icons/ExternalLink.vue';
import CtaCard from '@/componentsV2/molecules/CtaCard/CtaCard.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import AnalyticsCard from '@/componentsV2/molecules/AnalyticsCard/AnalyticsCard.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import CampaignService from '@/api/CampaignService';
import BusinessPayoutService from '@/api/BusinessPayoutService';
import { BusinessPayoutMethod } from '@/api/interfaces/business-payout-withdraw.interface';
import PlaidButton from '@/componentsV2/organisms/PlaidButton/PlaidButton.vue';
import flagKeys from '@/constants/flagKeys';

import {
  AnalyticsCardInsightVariant,
  EAnalyticsCardArrowDirection
} from '@/componentsV2/molecules/AnalyticsCard/AnalyticsCard.vue';

import {
  openCentralizedPopupWindow,
  closeOnWindowPopupUrlMatches
} from '@/utils/windowPopup';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    SectionWrapper,
    AnalyticsCard,
    CoinsIcon,
    CtaCard,
    FilledButton,
    FlexButton,
    Link,
    ExternalLinkIcon,
    Typography,
    PlaidButton
  }
})
export default class SellCoinsOverview extends Vue {
  @Prop() onUpdate!: any;
  @Prop({}) readonly dashboardData!: BusinessWalletDashboard | null;
  @Prop({ default: true }) loaded?: boolean;

  campaignService = new CampaignService();
  businessPayoutService = new BusinessPayoutService();
  stripeDashboardLink: string | null = null;

  withdrawLoading: boolean = false;
  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isCampaignManagementActive() {
    return this.flags.includes(flagKeys.sellCoinsCampaignManagement);
  }

  get isPlaidConnectActive() {
    return this.flags.includes(flagKeys.plaidConnect);
  }

  get isPlaidTestConnectActive() {
    return this.flags.includes(flagKeys.plaidTestConnect);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get tPrefix() {
    return 'sellCoins.overview';
  }

  get isWithdrawDisabled() {
    return (
      this.dashboardData &&
      (this.dashboardData.balance.available <= 0 ||
        !this.dashboardData.balance.passedWithdrawCommonValidations)
    );
  }

  get isPurchaseHistoryDisabled() {
    return !(this.dashboardData && this.dashboardData.coins.sold.amount > 0);
  }

  get isPayoutHistoryDisabled() {
    return !(
      this.dashboardData &&
      this.dashboardData.payouts.netPaidTotal +
        this.dashboardData.payouts.netInTransitTotal >
        0
    );
  }

  get coinsOverview() {
    let coinsVariation: {
      insightVariant: AnalyticsCardInsightVariant;
      arrowDirection?: EAnalyticsCardArrowDirection;
    } = {
      insightVariant: 'regular'
    };

    if (this.dashboardData) {
      if (this.dashboardData.coins.sold.diffFromLastMonth > 0) {
        coinsVariation = {
          insightVariant: 'success',
          arrowDirection: EAnalyticsCardArrowDirection.UP
        };
      } else if (this.dashboardData.coins.sold.diffFromLastMonth < 0) {
        coinsVariation = {
          insightVariant: 'danger',
          arrowDirection: EAnalyticsCardArrowDirection.DOWN
        };
      }
    }

    const overview: Record<string, AnalyticsCardListItem> = {
      coins: {
        variant: 'white',
        insightVariant: coinsVariation.insightVariant,
        infos: {
          title: '',
          largeTitle: String(this.$t(`${this.tPrefix}.cards.coins.label`)),
          disableAbbreviateAmount: true,
          amount: this.getDataOptional('formatted.coins.sold.amount', '--'),
          //prefixAmount: this.currencySymbol,
          arrowDirection: coinsVariation.arrowDirection,
          tooltipText: String(this.$t(`${this.tPrefix}.cards.coins.tooltip`)),
          insightText: this.getDataOptional('coins.sold.diffFromLastMonth')
            ? String(
                `${this.getDataOptional('coins.sold.diffFromLastMonth') ||
                  0}% ${this.$t(`${this.tPrefix}.cards.coins.insight`)}`
              )
            : '',
          counterFractionDigits: 2
        },
        components: {
          counter: {
            as: 'CoinsIcon'
          }
        }
      },
      withdraw: {
        variant: 'white',
        insightVariant: 'regular',
        infos: {
          title: '',
          largeTitle: String(this.$t(`${this.tPrefix}.cards.withdraw.label`)),
          disableAbbreviateAmount: true,
          tooltipIconPlacement: 'after-title',
          amount: this.getDataOptional('formatted.balance.available', '--'),
          // prefixAmount: this.currencySymbol,
          tooltipText: String(
            this.$t(`${this.tPrefix}.cards.withdraw.tooltip`)
          ),
          insightText: this.getDataOptional('balance.pending')
            ? String(
                `<strong>+${this.getDataOptional(
                  'formatted.balance.pending'
                )}</strong> ${this.$t(
                  `${this.tPrefix}.cards.withdraw.insight`
                )}`
              )
            : '<span />',
          counterFractionDigits: 2
        },
        components: {
          rightBottom: {
            as: 'Link',
            text: this.$t(`${this.tPrefix}.cards.withdraw.link`),
            type: 'submit',
            disabled: this.isPurchaseHistoryDisabled,
            colorSchema: 'new-gradient',
            action: this.gotoPurchaseHistory
          },
          rightTop: {
            as: this.isPlaidConnectActive ? 'PlaidButton' : 'FilledButton',
            text: this.$t(`${this.tPrefix}.cards.withdraw.btn`),
            type: 'submit',
            disabled: this.isWithdrawDisabled,
            colorSchema: 'new-gradient',
            action: this.onWithdrawClick,
            loading: this.withdrawLoading
          }
        }
      },
      payout: {
        variant: 'white',
        insightVariant: 'regular',
        infos: {
          title: '',
          largeTitle: String(this.$t(`${this.tPrefix}.cards.payout.label`)),
          disableAbbreviateAmount: true,
          amount: this.getDataOptional(
            'formatted.payouts.grossPaidTotal',
            '--'
          ),
          // prefixAmount: this.currencySymbol,
          tooltipText: String(this.$t(`${this.tPrefix}.cards.payout.tooltip`)),
          insightText: this.payoutInsighStatusMessage,
          counterFractionDigits: 2
        },
        components: {
          rightBottom: {
            text: this.$t(`${this.tPrefix}.cards.payout.btn`),
            disabled: this.isPayoutHistoryDisabled,
            as: 'Link',
            action: this.onPayoutsHistoryClick,
            class: '--payout-min-size'
          }
        }
      }
    };

    return Object.values(overview);
    // .filter(({ hidden }) => !hidden);
  }

  get payoutInsighStatusMessage(): string {
    if (this.dashboardData) {
      if (this.dashboardData.payouts.netInTransitTotal > 0) {
        return `${
          this.dashboardData.formatted.payouts.netInTransitTotal
        } ${this.$t(`${this.tPrefix}.cards.payout.insightProcessing`)}`;
      }

      if (this.dashboardData.payouts.last) {
        const formattedDate = DateUtils.formattedDate({
          date: new Date(this.dashboardData.payouts.last.date),
          applyTimezone: true
        });

        return `Your last payout of ${
          this.dashboardData.formatted.payouts.last.amount
        } was sent on ${formattedDate}`;
      }
    }

    return `${this.$t(`${this.tPrefix}.cards.payout.insightEmpty`)}`;
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  getDataOptional(path: string, fallbackValue: any = false) {
    return (
      path
        .split('.')
        .reduce(
          (a: any, v) => (!!a && typeof a === 'object' ? a[v] : null),
          this.dashboardData || {}
        ) || fallbackValue
    );
  }

  checkStripeConnect() {
    const { stripe_connection = null } = this.$route.query;

    if (stripe_connection === 'success') {
      this.$router.replace({ query: undefined });

      this.$analytics({
        eventCategory: 'Sell Coins | Stripe Connection',
        eventAction: 'route'
      });

      this.onWithdrawClick();
    }
  }

  gotoStripeLink(url = this.$store.state.stripe.connectURL) {
    this.$analytics({
      eventCategory: 'Gift Coins Page | Sell Gift Coins button',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Sell Gift Coins" button'
    });

    segmentIo.track('Stripe Dashboard Redirected');

    if (insideProviderIframe()) {
      const newWindow = (openCentralizedPopupWindow(
        url,
        'ConnectOauth'
      ) as unknown) as Window;

      closeOnWindowPopupUrlMatches(
        newWindow,
        process.env.VUE_APP_DASHBOARD_URL || 'twism'
      );
    } else {
      window.open(`${url}`, '_self');
    }
  }

  clickGoToStripe() {
    segmentIo.track('Clicked Go To Stripe Dashboard');
  }

  async openStripeConnectModal(autoRedirect = false) {
    const { data } = await this.campaignService.checkBusiness();
    const { payment } = data;

    if (autoRedirect) {
      if (window.parent) return window.parent.open(payment.url, '_blank');
      return window.open(payment.url, '_blank');
    }

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'stripeRedirect'
      }),
      {
        onConfirm: async () => {
          this.gotoStripeLink(payment.url);
        }
      }
    );
  }

  async openWithdrawModal() {
    this.withdrawLoading = true;

    const { data } = await this.businessPayoutService.getWithdrawDetails({
      method: BusinessPayoutMethod.STANDARD
    });

    this.withdrawLoading = false;

    if (!data) {
      return;
    }

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'withdrawSellCoins'
      }),
      {
        data,
        onConfirm: async () => {
          if (this.onUpdate) {
            this.onUpdate();
          }
        }
      }
    );
  }

  get stripeLinked() {
    if (this.isPlaidConnectActive) {
      return false;
    }

    const { stripeLinked } = this.businessInfo;
    return stripeLinked;
  }

  openStripeDetailsPendingModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'stripeDetailsPendingModal'
      }),
      {
        onConfirm: () => this.openStripeConnectModal(true),
        onGoToWithdraw: () => this.openWithdrawModal()
      }
    );
  }

  openStripeUnlockWithdrawModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'stripeUnlockWithdrawModal'
      }),
      {
        onConfirm: () => this.openStripeConnectModal(true)
      }
    );
  }

  async onWithdrawClick() {
    segmentIo.track('Clicked Withdraw Button', {
      'Stripe Linked': this.stripeLinked
    });

    if (this.isPlaidConnectActive || this.stripeLinked) {
      try {
        this.withdrawLoading = true;
        const { data } = await this.campaignService.checkStripeStatus();
        const { canWithdraw, hasNonBlockingPending } = data;
        if (canWithdraw) {
          if (hasNonBlockingPending) {
            return this.openStripeDetailsPendingModal();
          }
          return this.openWithdrawModal();
        }
        return this.openStripeUnlockWithdrawModal();
      } catch (error) {
        console.error(error);
        return this.$notification(
          'Stripe verification failed. Please try again in a few minutes',
          'error'
        );
      } finally {
        this.withdrawLoading = false;
      }
    }

    return this.openStripeConnectModal();
  }

  onPayoutsHistoryClick() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        `payoutsHistory`,
        false,
        true,
        true,
        true,
        true
      ),
      {
        onConfirm: async () => {}
      }
    );
  }

  gotoPurchaseHistory() {
    this.$router.push('/sell-coins/purchase-history');
  }

  async getStripeLink() {
    const { data } = await this.campaignService.checkBusiness();
    const { payment } = data;

    this.stripeDashboardLink = payment.url;
  }

  mounted() {
    this.checkStripeConnect();
    this.getStripeLink();
  }
}
